export const colors = {
  gray: {
    light: '#e3dfda',
    background: '#f9f9f9',
    // text: '#5f6368',
    star: '#DEDEDE',
    dark: '#726c66',
    disabled: '#b2aba5',
    shadow: '#f2f0ed',
    border: '#d8d8d8',
    main: '#f8f9fa',
    cardBorder: '#e8eaed',
    divider: '#dadce0',
    secondary: '#5f6368',
    border: '#938C85',
    close: '#474747',
    mist: '#F2F3F3',
  },
  yellow: {
    main: '#fbbc04',
    light: '#e6b52d',
    gold: '#E6B25D',
    star: '#ffaa06',
    badgesBg: '#EFDFD1',
    lightBeige: '#F8EED9'
  },
  black: {
    default: '#393532',
    dark: '#262321',
    darker: '#000',
    dark1: '#2d2725',
    info: '#544e4a',
    light: '#393533',
    badgeText: '#222222'
  },
  green: {
    dark: '#086274',
    light: '#22b322',
    primary: '#529c42',
    secondary: '#355b28',
    success: '#355b28',
    default: '#529c42',
    'success-bar': '#407b30'
  },
  white: {
    default: '#fff',
    chipBg: '#E3DDF4'
  },
  blue: {
    light: '#e8effa',
    link: '#324fa5',
    primary: '#476BC3',
    secondary: '#20337D',
    selected: '#e55751',
    lightblue: '#D8E5F9',
    btn: '#476BC3',
    dark: '#20337D',
    darker: '#223783',
    accentBlue: '#1976d2',
    chipText: '#3B2F78',
    hoverBg: '#b5d0ff',
    footerBg: '#121C4E',
    sidebarBorder: '#e5e7eb',
    sidebarBorderLight: '#f1f3f4',
    whisperBlue: '#ECE8F8'
  },
  red: {
    light: '#e55751',
    primary: '#C53422',
    dark: '#C53422',
    secondary: '#D0271D',
    pastelRed: '#FAD9D9'
  },
  orange: {
    default: '#f2635d'
  },
  navy: {
    darkest: '#010035',
    dark: '#121C4E',
    medium: '#20337D'
  },
  purple: {
    light: '#7967AE',
    main: '#CFC5EC'
  },
  MYAPPGRAY: {
    dark: '#767676',
    light: '#f5f5f5'
  },
  MYAPPRED: {
    dark: '#d40f0f',
    light: '#fffbfb'
  },
  MYAPPGREEN: {
    dark: '#69ba32',
    light: '#fafff5'
  },
  MYAPPYELLOW: {
    dark: '#ffb400',
    light: '#fdfcf6'
  },
  SMART_SEARCH_INDICATOR: {
    light: ' #F7F6F4'
  }
};
